export default __webpack_public_path__ + "fonts/Auctions-White.svg";